export default __webpack_public_path__ + "static/media/compas_create_single_perimeter.a8d5dbaf.gif";